import type { NextPage } from 'next'
import styles from '../../styles/form/cityInput.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { joinClassnames } from 'helpers/classNames'
import { faLock, faEnvelope, faUser, faPlus, faCity } from '@fortawesome/free-solid-svg-icons'
import { Country, City } from 'country-state-city';
import { useMemo } from 'react'
import TextInput from 'react-autocomplete-input';
import 'react-autocomplete-input/dist/bundle.css';
import { capitalise } from 'helpers/general'

library.add(faLock, faEnvelope, faUser, faPlus, faCity)

interface Props {
  country: string
  text: string
  placeholder?: string
  onChange: (v: string) => void
  icon?: any
  type: string
  color?: string
  label?: string
  smallPadding?: boolean
  required?: boolean
  height?: string
  lineHeight?: boolean
  disabled?: boolean
  shadow?: boolean
}

export const makeCountryObject = (countryName: string) => {
  return {
    value: Country.getAllCountries().find((c) => c.name === countryName)?.isoCode || "",
    label: countryName || ""
  }
}

const CityInputComponent: NextPage<Props> = (props: Props) => {
  const options = useMemo(() => {
    return City.getCitiesOfCountry(Country.getAllCountries().find(c => c.name.toLowerCase() === props.country.toLowerCase())?.isoCode || "")?.map(c => (c.name))
  }, [props.country])

  const textInputClassName = joinClassnames([
    styles.textarea_input,
    styles.city_input,
    props.icon && styles.text_input_with_icon,
    // props.smallPadding && styles.country_input_small_padding,
    props.color === "white" && styles.make_input_white,
    props.smallPadding ? styles.textarea_small_padding : styles.input_padding,
    props.lineHeight && styles.line_height,
    props.shadow && styles.shadow,
  ])

  return (
    <>
      {props.label && <div className={styles.label}>{(props.required ? "* " : "") + props.label}</div>}

      <div className={styles.cityInput_container} style={{ height: props.height }}>
        {props.icon &&
          <div className={styles.icon_wrapper}>
            <FontAwesomeIcon
              className={styles.icon}
              icon={props.icon}
            />
          </div>
        }

        <TextInput
          disabled={props.disabled}
          className={textInputClassName}
          style={{ height: props.height }}
          trigger=""
          placeholder={props.placeholder}
          options={options ?? []}
          value={capitalise(props.text)}
          onChange={((value: string) => {
            props.onChange(value)
          }) as any}
        />
      </div>
    </>
  )
}

export default CityInputComponent
